import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPIF } from 'redux/crm/project/pifSlice';

// Loads the PIF named by the URL.
//
// The edit form and the print preview used to read it straight out of
// `location.state`, a snapshot captured whenever the detail page last rendered.
// React Router replays that entry on back/forward and keeps it across reloads,
// so both pages could show a pre-edit copy — and the edit form would then SAVE
// that copy back over the user's work. Opening either URL directly crashed for
// the same reason: there was no state to destructure.
//
// `initialPif` is only a placeholder to render while the request is in flight;
// pass it from pages that hold no form state.
export const usePifFromRoute = (initialPif = null) => {
  const {
    project_id: projectId,
    building_id: buildingId,
    adaptation_id: adaptationId,
    id: pifId,
  } = useParams();

  const dispatch = useDispatch();
  const [pif, setPif] = useState(initialPif);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    dispatch(getPIF({ projectId, buildingId, adaptationId, pifId }))
      .unwrap()
      .then((payload) => {
        if (cancelled) return;
        setPif(payload?.data?.attributes ?? null);
        setError(null);
      })
      .catch((reason) => {
        if (cancelled) return;
        setError(reason?.message || 'Failed to load the PIF.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch, projectId, buildingId, adaptationId, pifId]);

  return { pif, loading, error };
};

export default usePifFromRoute;
